/**
 * Resolves once the browser has painted, so that a pending state shows before
 * work that blocks the thread, like (de)serializing a large legend.
 */
export function waitForPaint() {
  return new Promise<void>((resolve) => {
    // The frame callback runs before the paint; the timeout after it.
    requestAnimationFrame(() => setTimeout(resolve))
  })
}
